import { Box, Typography } from "@mui/material";
import MzButton from "@markaaz/ui/MzButton";
import { MzDialog, MzDialogContent } from "@markaaz/ui/MzDialogControls";
import { HourGlassIcon } from "../../../assets/icons";

const sx = {
  root: {
    display: "flex",
    gap: "50px",
    width: "500px",
    marginBottom: 5
  }
};

export default function SessionExpired({ show, onClick }) {
  return (
    <MzDialog open={show}>
      <MzDialogContent sx={sx.root}>
        <Box>
          <HourGlassIcon />
        </Box>
        <Typography variant="h5" color="darkBlue.c100">
          Your session has expired.
        </Typography>
        <MzButton variant="contained" color="primary" size="large" onClick={onClick}>
          Sign Back In
        </MzButton>
      </MzDialogContent>
    </MzDialog>
  );
}
